export default "__VITE_ASSET__DbwG83Tn__"